import { ReactNode } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { BreadcrumbSchema } from "@/components/StructuredData";
import FloatingParticles from "@/components/FloatingParticles";

interface BreadcrumbItem {
  name: string;
  url: string;
}

interface LayoutProps {
  children: ReactNode;
  seoTitle?: string;
  seoDescription?: string;
  seoKeywords?: string;
  seoUrl?: string;
  breadcrumbs?: BreadcrumbItem[];
  showFloatingParticles?: boolean;
  showHeader?: boolean;
  showFooter?: boolean;
}

const Layout = ({
  children,
  seoTitle,
  seoDescription,
  seoKeywords,
  seoUrl,
  breadcrumbs,
  showFloatingParticles = false,
  showHeader = true,
  showFooter = true,
}: LayoutProps) => {
  return (
    <div className="min-h-screen bg-background relative">
      {/* SEO Component - Always rendered for GTM tracking */}
      <SEO
        title={seoTitle}
        description={seoDescription}
        keywords={seoKeywords}
        url={seoUrl}
      />
      
      {/* Breadcrumb Schema - Only if breadcrumbs provided */}
      {breadcrumbs && <BreadcrumbSchema items={breadcrumbs} />}
      
      {/* Floating Particles - Optional */}
      {showFloatingParticles && <FloatingParticles />}
      
      {/* Main Content Wrapper */}
      <div className={showFloatingParticles ? "relative z-10" : ""}>
        {/* Header - Optional */}
        {showHeader && <Header />}
        
        {/* Main Content */}
        {children}
        
        {/* Footer - Optional */}
        {showFooter && <Footer />}
      </div>
    </div>
  );
};

export default Layout;
